<template>
  <div class="ima-dashboard container-fluid">

    <div class="ima-dashboard__header">
      <h1 class="title">Dashboard</h1>

      <button class="button is-white is-medium" @click="fetchDashboardData()">
        <b-icon icon="autorenew"></b-icon>
      </button>
    </div>

    <div class="box">
      <h3 class="subtitle is-5">Neueste Schilder</h3>

      <ima-loading-spinner v-if="dashboard.isLoading"></ima-loading-spinner>

      <b-table v-else class="ima-dashboard-list__table" :data="dashboard.data.new" :striped="true" :mobile-cards="true" default-sort="['id']">

        <template slot-scope="props">
          <b-table-column field="id" label="ID" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name" label="Bezeichnung" sortable>
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="name" label="Vorschau">
            <router-link :to="{ name: routes.SIGN_DETAILS, params: { id: props.row.id}}">
              <ima-sign-thumbnail :sign="props.row" />
            </router-link>
          </b-table-column>

          <b-table-column field="name" label="Status" sortable>
            <ima-sign-status-label :status="props.row.status" />
          </b-table-column>

          <b-table-column field="signType" label="Typ" sortable>
            {{ props.row.signType.name }}
          </b-table-column>

          <b-table-column field="exhibition" label="Messe" sortable>
            {{ props.row.exhibition.name }}
          </b-table-column>

          <b-table-column field="createdAt" label="Erstellt" class="nowrap">
            {{props.row.createdAt | moment('DD.MM.YYYY HH:mm')}}
          </b-table-column>

          <b-table-column field="actions" label=" ">
            <div class="control">
              <router-link :to="{ name: routes.SIGN_DETAILS, params: { id: props.row.id}}" class="button round-button is-primary">
                <b-icon icon="arrow_forward"></b-icon>
              </router-link>
            </div>
          </b-table-column>
        </template>

        <div slot="empty">
          Keine Schilder verfügbar
        </div>
      </b-table>

    </div>
    <div class="box">
      <h3 class="subtitle is-5">Zuletzt bearbeitet</h3>
      <ima-loading-spinner v-if="dashboard.isLoading"></ima-loading-spinner>

      <b-table v-else class="ima-dashboard-list__table" :data="dashboard.data.leastRecent" :striped="true" :mobile-cards="true" default-sort="['id']">

        <template slot-scope="props">
          <b-table-column field="id" label="ID" sortable numeric>
            {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name" label="Bezeichnung" sortable>
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="name" label="Vorschau">
            <router-link :to="{ name: routes.SIGN_DETAILS, params: { id: props.row.id}}">
              <ima-sign-thumbnail :sign="props.row" />
            </router-link>
          </b-table-column>

          <b-table-column field="name" label="Status" sortable>
            <ima-sign-status-label :status="props.row.status" />
          </b-table-column>

          <b-table-column field="signType" label="Typ" sortable>
            {{ props.row.signType.name }}
          </b-table-column>

          <b-table-column field="exhibition" label="Messe" sortable>
            {{ props.row.exhibition.name }}
          </b-table-column>

          <b-table-column field="updatedAt" label="Zuletzt bearbeitet" class="nowrap">
            {{props.row.createdAt | moment('DD.MM.YYYY HH:mm')}}
          </b-table-column>

          <b-table-column field="actions" label=" ">
            <div class="control">
              <router-link :to="{ name: routes.SIGN_DETAILS, params: { id: props.row.id}}" class="button round-button is-primary">
                <b-icon icon="arrow_forward"></b-icon>
              </router-link>
            </div>
          </b-table-column>
        </template>

        <div slot="empty">
          Keine Schilder verfügbar
        </div>
      </b-table>

    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { fetchDashboardData } from '@/store/modules/dashboard'
import LoadingSpinner from '@/components/LoadingSpinner'
import SignStatusLabel from '@/components/SignStatusLabel'
import SignThumbnail from '@/components/SignThumbnail'
import routes from '@/mixins/routes'

export default {
  name: 'ima-dashboard',
  mixins: [routes],
  components: {
    'ima-loading-spinner': LoadingSpinner,
    'ima-sign-status-label': SignStatusLabel,
    'ima-sign-thumbnail': SignThumbnail
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['dashboard', 'user'])
  },
  methods: {
    ...mapActions([fetchDashboardData])
  },
  created () {
    this.fetchDashboardData()
  }
}
</script>


<style scoped lang="scss">
.ima-dashboard {
  &__header {
    align-items: baseline;
    display: flex;

    .button {
      margin-left: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue